module.exports = __webpack_public_path__ + "media/images/features/beautiful_and_fun_img-89029b0fd6e030ea68a5bf7198ff7d9c.png";